import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  NavController,
  Platform,
  LoadingController,
} from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';

import {
  AppState,
  AuthService,
  EventService,
  NativeClientService,
} from '../services';
import { Store } from '@ngrx/store';
import { UserActions, MyPenmateActions } from '../actions';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { LoginPage } from '../pages';

@Component({
  selector: 'pm-profile-page',
  templateUrl: 'penmate-profile.html',
  styleUrls: ['./penmate-profile.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PenmateProfile implements OnInit {
  penmate: any;
  modal: any;
  user: any;
  isNative;
  isMobile;

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    public route: ActivatedRoute,
    public authService: AuthService,
    public eventService: EventService,
    public loadingCtrl: LoadingController,
    public userActions: UserActions,
    public myPenmateActions: MyPenmateActions,
    public store: Store<AppState>,
    private nativeService: NativeClientService,
  ) {
    platform.ready().then(() => {
      this.store.dispatch(
        this.myPenmateActions.findPenmate(this.route.snapshot.paramMap.get('id')),
      );
    });
  }

  ngOnInit() {
    this.isNative = !!this.nativeService.active;
    this.isMobile = this.platform.is('mobile');

    this.authService.authenticate().subscribe(({ isAuthenticated, user }) => {
      if (isAuthenticated && user) {
        this.user = user;
        this.store
          .select(state => state.myPenmates.currentPenmate)
          .pipe(take(1))
          .subscribe(penmate => {
            if (penmate) {
              this.navCtrl.navigateRoot('/my-penmates');
            }
          });
      } else {
        this.store
          .select(state => state.myPenmates.currentPenmate)
          .subscribe(penmate => {
            this.penmate = penmate;
            if (this.penmate) {
              this.penmate.showMap = true;
            }
          });
      }
    });
  }

  onExploreMedia() {
    const penmate = this.penmate;
    this.nativeService.sendMessage({ type: 'SHOW_LIBRARY', payload: { penmate } });
  }

  onCreateMessage = async () => {
    const penmate = this.penmate;
    const loading = await this.loadingCtrl.create({ spinner: 'dots' });
    await loading.present();
    this.authService.authenticate().subscribe(async ({ isAuthenticated, user }) => {
      await loading.dismiss();
      if (isAuthenticated) {
        this.store.dispatch(this.userActions.loginUser(user));

        this.eventService.track('create-letter', { penmate_id: penmate.id });
        return this.navCtrl.navigateForward(
          `/penmates/${this.route.snapshot.paramMap.get('id')}/messenger?messageType=letter`,
        );
      }
      this.navCtrl.navigateForward('/login');
    });
  };

  onCreatePostcard = async () => {
    const penmate = this.penmate;

    const loading = await this.loadingCtrl.create({ spinner: 'dots' });
    await loading.present();
    this.authService.authenticate().subscribe(async ({ isAuthenticated, user }) => {
      await loading.dismiss();
      if (isAuthenticated) {
        this.store.dispatch(this.userActions.loginUser(user));

        this.eventService.track('create-postcard', { penmate_id: penmate.id });
        return this.navCtrl.navigateForward(
          `/penmates/${this.route.snapshot.paramMap.get('id')}/messenger?messageType=postcard`,
        );
      }
      this.navCtrl.navigateForward('/login');
    });
  };

  onViewMessages() {
    const penmate = this.penmate;

    this.store.dispatch(this.myPenmateActions.viewPenmate(penmate));
    this.navCtrl.navigateForward(`/penmates/${penmate.id}/messenger`);

    this.eventService.track('view-messages', { penmate_id: penmate.id });
  }

  // onCreateMessage(penmate) {
  //   this.store.dispatch(this.myPenmateActions.viewPenmate(penmate));

  //   //this.store.dispatch(this.createMessageActions.resetMessage());
  //   this.modal = this.modalCtrl.create(MessageCreatorPage);
  //   this.modal.present();
  // }
}
